import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as $ from 'jquery';

import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';

import { Slug } from '@fnv-core/utils';
import { decodeHtmlEntities } from '../../helpers/decode-html-entities';
import { getAllUrlParams } from '../../jslibs/urlparams';

import { reactStartupStore } from "../helpers/ReactStartup";
import { MijnFNVPageContext } from '../presentational/pages/helpers/MijnFNVPageContext';

import { StepsContainer } from '../containers/StepsContainer';
import { EditDataPage } from '../presentational/pages/EditDataPage';
import { IFormConfig } from '../interfaces/FormConfig';
import { KenticoPageDefinition, KenticoFormViewmodel } from '../presentational/pages/interfaces/PageInterfaces';
import { widgetClassNames } from '../presentational/pages/helpers/PageHelpers';

import { PageTypeService } from '../services/PageTypeService';

import { ErrorMessageService } from '../services/ErrorMessageService';


import { StringHelpers } from '../helpers/StringHelpers';
import { FormConfigHelper } from './helpers/FormConfigHelper';
import { IFormDefinition } from '../interfaces/FormDefinition';
import { createRef } from 'react';

function initReact(formConfig: IFormConfig, formDefinitions: IFormDefinition | IFormDefinition[], rootId?: string) {
  if (!formDefinitions) {
    return false;
  }

  if (Array.isArray(formDefinitions)) {
    formDefinitions = formDefinitions[0];
  }

  if (!formDefinitions) {
    return false;
  }

  let urlParams = getAllUrlParams();
  let orgFormConfig = formConfig; 

  formConfig.PopupErrorMessageDescription = StringHelpers.parseHtmlEncodedString(formConfig.PopupErrorMessageDescription);

  if (formDefinitions && formDefinitions.form && formDefinitions.form.field) {
    const fields = formDefinitions.form.field;

    const formConfigField = fields.find(field => field.settings.controlname === 'FormConfig');

    if (formConfigField) {
      let formConfigFromForm = formConfigField.settings.FormConfig;
      if (formConfigFromForm) {
        formConfig = JSON.parse(formConfigFromForm);
        if (orgFormConfig) {
          FormConfigHelper.MergeConfigs(formConfig, orgFormConfig);
        }

        if (formConfigField.settings.SummaryValueBelowFields) {
          formConfig.summaryValueBelowFields = !!formConfigField.settings.SummaryValueBelowFields;
        }
      }
    }
  }

  let store = reactStartupStore(formConfig, formDefinitions);
  const providerValue = {
    routeState: {},
    pathParam: urlParams.id || "",
    bronCode: urlParams.broncode || "",
    search: location.search || "",
  };
  
  ErrorMessageService.setErrorMessagePropertes(
    formConfig.PopupErrorMessageTitle || "",
    formConfig.PopupErrorMessageDescription || "",
    formConfig.PopupErrorMessagePhoneNumber || "",
    formConfig.PopupErrorMessagePhoneNumberInfo || "",
    formConfig.PopupErrorMessageButtonText || "",
    formConfig.PopupNotAllDataCanBeRetrievedErrorMessage || ""
  );

  let form: KenticoFormViewmodel = {
    ClassName: widgetClassNames.formClass,
    editMode: true,    
    withLinkToFormPage: false,

    FormName: "Form",
    FormType: "Default",
    FormDefinition: formDefinitions,
    FormConfig: formConfig,
    EditMode: true,
    WithLinkToFormPage: false,
    noAutoGenerateSummary: formConfig.noAutoGenerateSummary !== undefined ? formConfig.noAutoGenerateSummary : false,
    NextLink: "",
    LinkText : "",
    DocumentID : "1",

    SummaryIntro : "",
    OnSuccessPopupMessage : (formConfig as any).onSuccessPopupMessage ? decodeHtmlEntities((formConfig as any).onSuccessPopupMessage) : "",
    OnSuccessPopupMessageVisualCheck: "",
    OnSuccessPopupDescription : (formConfig as any).onSuccessPopupDescription ? decodeHtmlEntities((formConfig as any).onSuccessPopupDescription) : "",

    RestApiEndpoint : "",
    EditPageLink : "",
    OnSubmitSuccessLink : "",
    OnSubmitFailureLink : "",

    OnSubmitSuccessButton1Link: "",
    OnSubmitSuccessButton1LinkText: "",
    OnSubmitSuccessButton2Link: "",
    OnSubmitSuccessButton2LinkText: "",
    MijnFnvFormLinks : [],
    ErrorMessageTitle : (formConfig as any).PopupErrorMessageTitle,
    ErrorMessageDescription : (formConfig as any).PopupErrorMessageDescription,
    ErrorMessagePhoneNumberInfo : (formConfig as any).PopupErrorMessagePhoneNumberInfo,
    ErrorMessagePhoneNumber : (formConfig as any).PopupErrorMessagePhoneNumber,
    ErrorMessageEmailInfo : (formConfig as any).PopupErrorMessageEmailInfo,
    ErrorMessageEmail : (formConfig as any).PopupErrorMessageEmail,
    ErrorMessageButtonText : (formConfig as any).PopupErrorMessageButtonText
  };

  let kenticoPage : KenticoPageDefinition = {
    MijnFnvEditPagina : {
      Alias: "Alias",
      TaskIntroText: "TaskIntroText",
      HideSteps: formConfig.hideSteps,
      Titel: $(".react-content h1").text(),

      ShowSideBar: false,
      MenuType: "eenvoudig",
      BackToPageLinkText: "",
      BackToPageLinkUrl: "",
      PageWidth: (formConfig.standaloneFormInSite ? "breed" : "smal"),
      IncludeAdditionalIdInBackLink: false,
      ModernLayout: false,    
    },
    MijnFnvTopTaken : { 
      TaskIntroText: "",
      MijnFnvTopTaken: []
    },
    RelatedViewModels: [
      { MijnFnvContentBlockModel: form }
    ],
    Menu: [],
    Footer: {},
    HideSteps: formConfig.hideSteps
  };

  PageTypeService.setPageType("edit");

  let hulpCta = undefined;
  if ($(".hulp-cta").length > 0) {
    hulpCta = $("<div>").append($(".hulp-cta").clone());

    $(hulpCta).find(" [data-add-style-on-intersect]").each((index, element) => {      
      const style = $(element).attr("data-add-style-on-intersect");
      $(element).attr("style", style);
    });
  }

  const standaloneFormInSite = (formConfig.standaloneFormInSite !== undefined && formConfig.standaloneFormInSite);

  let layoutClass = $("#root").attr("data-layout") || "";
  let layoutType = "";
  if (layoutClass !== "") {
    layoutType = layoutClass;
    layoutClass = "editpage-container__layout-" + layoutClass;    
  }

  // When layout is `modern`, we need to define specific paddings for certain screen sizes
  let paddingClasses = "";
  if(layoutType === "modern"){
    paddingClasses = "p-0 p-md-2";
  }

  const stepsContainerRef = createRef<HTMLDivElement>();
  kenticoPage.stepsContainerRef = stepsContainerRef;
  
  ReactDOM.render(
    <Router basename='/mijn-fnv'>
      <Provider store={store}>
        <>
          <MijnFNVPageContext.Provider value={providerValue}>

            {formConfig.hideSteps || form.FormType == "FormV2" ? <></> : <StepsContainer cssClass={layoutClass !== "" ? layoutClass + "-steps" : ""}></StepsContainer>}
            {form.FormType == "FormV2" ? <div className={layoutClass !== "" ? layoutClass + "-steps" : ""} ref={stepsContainerRef}></div> : <></>}
           
            <div className={"mijn-fnv animation__fade-in " + (formConfig.kenticoFormName ? Slug.fromString(formConfig.kenticoFormName) : "")}>
              <div className={(standaloneFormInSite ? "content" : "container content") + " " + layoutClass + " " + paddingClasses}>
                  <EditDataPage kenticoPage={kenticoPage}
                    pathName=""
                    kenticoPageType=""
                    sideBarHtml={$(hulpCta).html()}
                    layoutType={layoutType}
                    showTitleBlock={layoutType == "modern" && (formConfig.showTitleBlock === undefined || !!formConfig.showTitleBlock)}
                    stickySidebar={layoutType == "modern" && (formConfig.stickySidebar === undefined || !!formConfig.stickySidebar)}
                    withBackLink={false}
                    customEditPageClass={formConfig.customEditPageClass}
                    subTitle={$(".react-content h2").text()}
                    introText={$(".react-content .intro").text()}
                    standaloneFormInSite={formConfig.standaloneFormInSite}
                    content={$(".react-content .js-content").html()}
                    contentAfterForm={$(".react-content .js-content-after-form").length > 0}
                    ></EditDataPage>
              </div>
            </div>
          </MijnFNVPageContext.Provider>       
        </>
      </Provider>
    </Router>,
    document.getElementById(rootId || 'root')
  );
}

export { initReact };
